import { Commit } from 'vuex';
import * as Types from './types';
import * as API from './api';
import { ICalendarState, IParamsCalendar } from './interface';
import { Toast } from 'vant';

const loginUser = localStorage.loginUser && localStorage.loginUser !== '' ? JSON.parse(localStorage.loginUser) : {};

const checkbox: any = localStorage.getItem('calendarEventTypeCheckBox');
const state: ICalendarState = {
    loadingSycnMemeber: false,
    sycnMemeberInfo: {},
    syncState: 2,
    calendarEvents: {},
    requestStutas: false,
    selectData: {},
    checkbox: checkbox
        ? JSON.parse(checkbox)
        : {
              projectEvents: true,
              preSaleEvent: true,
              meetingEvents: true,
              scheduleEvents: true,
              vacationEvents: true,
              serviceEvents: true,
              fnEvents: true,
              saleEvents: true,
              marketEvents: true,
              birthdayEvents: true,
              anniversaryEvents: true,
          },
    BusinessUnitList: [],
    DepartmentUsers: [],
    currentDept: { title: loginUser.DepartmentName, key: loginUser.DepartmentGUID },
    currentUser: {},
    followedUsers: {} as any,
};

const actions = {
    async [Types.GET_SYNC_MEMBER_MESSAGES](context: { commit: Commit; state: ICalendarState }, params: any) {
        let sycnMemeberInfo: any = {};
        context.commit(Types.GET_SYNC_MEMBER_MESSAGES, { loading: true, sycnMemeberInfo });
        sycnMemeberInfo = await API.GetSyncMemberMessages(params);
        context.commit(Types.GET_SYNC_MEMBER_MESSAGES, { loading: false, sycnMemeberInfo });
    },
    async [Types.SCHEDULE_INVITATION_AGREED](context: { commit: Commit; state: ICalendarState }, params: any) {
        Toast.loading('');
        const result = await API.ScheduleInvitationAgreed(params);
        context.commit(Types.SCHEDULE_INVITATION_AGREED, result);
    },
    async [Types.SCHEDULE_INVITATION_REFUSED](context: { commit: Commit; state: ICalendarState }, params: any) {
        Toast.loading('');
        const result = await API.ScheduleInvitationRefused(params);
        context.commit(Types.SCHEDULE_INVITATION_REFUSED, result);
    },
    async [Types.GET_CALENDAR_EVENTS](context: { commit: Commit; state: any }, params: IParamsCalendar) {
        const result = await API.getCalendarEventsByUser(params);
        context.commit(Types.GET_CALENDAR_EVENTS, result || state.calendarEvents);
    },
    async [Types.GET_BUSINESS_UNIT_LIST](context: { commit: Commit; state: ICalendarState }, params: any) {
        const result = await API.getBusinessUnitList(params);
        context.commit(Types.GET_BUSINESS_UNIT_LIST, result || state.BusinessUnitList);
    },
    async [Types.GET_DEPART_MEND_USERS](context: { commit: Commit; state: ICalendarState }, params: any) {
        const result = await API.getDepartmentUsers(params);
        context.commit(Types.GET_DEPART_MEND_USERS, result || state.DepartmentUsers);
    },
    async [Types.CURRENT_USER_INFO](context: { commit: Commit; state: ICalendarState }, params: any) {
        context.commit(Types.CURRENT_USER_INFO, params);
    },
    async [Types.CURRENT_DEPT_INFO](context: { commit: Commit; state: ICalendarState }, params: any) {
        context.commit(Types.CURRENT_DEPT_INFO, params);
    },
    async [Types.GET_FOLLOWED_USERS](context: { commit: Commit; state: ICalendarState }, params: any) {
        const result = await API.getFollowedUsers(params);
        context.commit(Types.GET_FOLLOWED_USERS, result || state.followedUsers);
    },
    async [Types.CHANGE_CURRENT_USER](context: { commit: Commit; state: ICalendarState }) {
        context.commit(Types.CHANGE_CURRENT_USER);
    },
};

// 更改当前选择人
const changeCurrentUser = (state: ICalendarState) => {
    if (state.DepartmentUsers.UserInfoList && state.DepartmentUsers.UserInfoList.length > 0) {
        // 是否有当前人
        const noUser = !state.currentUser.UserGUID || state.currentUser.UserGUID === '';
        if (noUser) {
            state.currentUser = state.DepartmentUsers.UserInfoList[0];
        } else {
            // 当前人是否在部门列表里
            const info = state.DepartmentUsers.UserInfoList.find((item: any) => item.UserGUID === state.currentUser.UserGUID);
            if (!info) state.currentUser = state.DepartmentUsers.UserInfoList[0];
        }
    }
};

const mutations = {
    [Types.GET_SYNC_MEMBER_MESSAGES](state: ICalendarState, payload: any) {
        state.loadingSycnMemeber = payload.loading;
        state.sycnMemeberInfo = payload.sycnMemeberInfo;
        state.syncState = payload.sycnMemeberInfo.messageStatus !== undefined ? payload.sycnMemeberInfo.messageStatus : 2;
    },
    [Types.SCHEDULE_INVITATION_AGREED](state: ICalendarState, payload: any) {
        if (payload && payload.result) {
            state.syncState = 1;
            Toast.success('同意成功');
        }
    },
    [Types.SCHEDULE_INVITATION_REFUSED](state: ICalendarState, payload: any) {
        if (payload && payload.result) {
            state.syncState = 0;
            Toast.success('拒绝成功');
        }
    },
    [Types.GET_CALENDAR_EVENTS](state: any, calendarEvents: any) {
        state.calendarEvents = calendarEvents;
    },
    [Types.GET_BUSINESS_UNIT_LIST](state: ICalendarState, BusinessUnitList: any) {
        state.BusinessUnitList = BusinessUnitList;
    },
    [Types.GET_DEPART_MEND_USERS](state: ICalendarState, DepartmentUsers: any) {
        state.DepartmentUsers = DepartmentUsers;
        changeCurrentUser(state);
    },
    [Types.CHANGE_CURRENT_USER]() {
        changeCurrentUser(state);
    },
    [Types.CURRENT_DEPT_INFO](state: ICalendarState, currentDept: any) {
        state.currentDept = currentDept;
    },
    [Types.CURRENT_USER_INFO](state: ICalendarState, currentUser: any) {
        state.currentUser = currentUser;
    },
    [Types.GET_FOLLOWED_USERS](state: ICalendarState, followedUsers: any) {
        state.followedUsers = followedUsers;
        if (followedUsers.UserInfoList && followedUsers.UserInfoList.length > 0) {
            // 是否有当前人
            const noUser = !state.currentUser.UserGUID || state.currentUser.UserGUID === '';
            if (noUser) {
                state.currentUser = followedUsers.UserInfoList[0];
            } else {
                // 当前人是否在部门列表里
                const info = followedUsers.UserInfoList.find((item: any) => item.UserGUID === state.currentUser.UserGUID);
                if (!info) state.currentUser = followedUsers.UserInfoList[0];
            }
        }
    },
};

export default { namespaced: true, state, actions, mutations };
